
export default class ResultCount {

    async init(): Promise<void> {
        this.copyResults();
        jQuery(document).on('ajaxComplete', () => this.copyResults());
    }

    async copyResults(): Promise<void> {
        const resultCount: HTMLElement | null = document.querySelector('.woocommerce-result-count');
        const resultPlaceholder: HTMLElement | null = document.querySelector('.mobile-offer-results-count');

        if (!resultCount || !resultPlaceholder) return;

        resultPlaceholder.innerHTML = resultCount.innerHTML;

    }

}
